class SuccessStoryInfoCreate
    constructor: (options) ->
        @.$el = null

        @.allPostsText = options?.allPostsText ? 'Alle Beiträge von ##u##'
        @.attrs = options?.attrs ? false
        @.postsLink = options?.postsLink ? false
        @.profilePic = options?.profilePic ? {}
        @.sectionLink = options?.sectionLink ? false
        @.sendByText = options?.sendByText ? 'Eingesandt von'
        @.smokeFree = options?.smokeFree ? false
        @.smokeFreeText = options?.smokeFreeText ? 'Rauchfrei seit'
        @.tag = options?.tag ? 'div'
        @.tip = options?.tip ? false
        @.tipLink = options?.tipLink ? false
        @.tipText = options?.tipText ? 'Mein Lieblingstipp'
        @.toTipText = options?.toTipText ? 'Zum Tipp'
        @.toUserSectionText = options?.toUserSectionText ? 'Zu ##u##s Forumsbereich'
        @.userName = options?.userName ? 'n/a'

        @.CreateElement()
        return @.$el
    
    CreateElement: ->
        @.$el = document.createElement @.tag
        @.$el.classList.add 'success-story-info'
        if @.attrs
            @.$el = window.appUtils.Attributes @.attrs, @.$el
        @.$el.innerHTML = "
            <div class='success-story-info__head'>
                <div class='success-story-info__head__user'>
                    <div class='success-story-info__head__user__title'>#{ @.sendByText }:</div>
                    <div class='success-story-info__head__user__name'>#{ @.userName }</div>
                    #{ if @.smokeFree then "<div class='success-story-info__head__user__smoke-free'>#{ @.smokeFreeText }:<span>#{ @.smokeFree }</span></div>" else "" }
                </div>
            </div>
            #{ if @.sectionLink || @.postsLink then "<div class='success-story-info__links'></div>" else "" }
            #{ if @.tip then "
                <div class='success-story-info__tip'>
                    <div class='success-story-info__tip__head'>#{ @.tipText }</div>
                    <div class='success-story-info__tip__text'>#{ @.tip }</div>
                </div>
            " else "" }
        "
        @.$el.querySelector '.success-story-info__head'
            .appendChild window.CreateProfilePic {
                attrs: {
                    class: ['success-story-info__head__profile-pic']
                }
                badge: @.profilePic.badge ? false
                medium: true
                pic: @.profilePic.pic ? false
                onWhite: true
            }
        if @.sectionLink
            @.$el.querySelector '.success-story-info__links'
                .appendChild window.CreateLinkButton {
                    attrs: {
                        class: ['success-story-info__section-link']
                    }
                    link: @.sectionLink
                    text: @.toUserSectionText.replace('##u##',@.userName)
                }
        if @.postsLink
            @.$el.querySelector '.success-story-info__links'
                .appendChild window.CreateLinkButton {
                    attrs: {
                        class: ['success-story-info__posts-link']
                    }
                    link: @.postsLink
                    text: @.allPostsText.replace('##u##',@.userName)
                }
        if @.tip && @.tipLink
            @.$el.querySelector '.success-story-info__tip'
                .appendChild window.CreateLinkButton {
                    attrs: {
                        class: ['success-story-info__tip__link']
                    }
                    link: @.tipLink
                    text: @.toTipText.replace('##u##',@.userName)
                }
        return

window.CreateSuccessStoryInfo = (options) ->
    return new SuccessStoryInfoCreate options